module.exports = __webpack_public_path__ + "static/homepage-desktop-food-app-dd2c0eb49fc2fbeeb978907c2c1a8878.jpg";